import { api } from "../../lib/api";

export interface AppNotification {
  id: string;
  type: string;
  title: string;
  body: string | null;
  data: Record<string, unknown> | null;
  read: boolean;
  createdAt: string;
}

export const listNotifications = () =>
  api<{ data: AppNotification[]; nextCursor: string | null; unread: number }>(
    "/me/notifications?limit=50",
  );

export const markRead = (id: string) =>
  api<{ notification: AppNotification }>(`/me/notifications/${id}/read`, { method: "POST" }).then(
    (r) => r.notification,
  );
